import { Model } from '@/models/Model';
import { BackgroundEvent } from '@/support/CalendarDefaults';
import client from '@/support/Client';
import { DateTime } from 'luxon';

export class Hour extends Model
{
  protected $name: string = 'Hour';
  protected $endpoint: string = '/hours';
  protected $fillable: string[] = ['starts_at', 'ends_at', 'project', 'employee', 'hour_type', 'description'];

  public starts_at?: string;
  public id?: string;
  public ends_at?: string;
  public hour_type?: string;
  public description?: string;

  get calendarEvent() {
    const parsedEvent: CalendarEvent = {
      id: this.id || '',
      title: `${DateTime.fromSQL(this.starts_at || '').toFormat('HH:mm')} - ${DateTime.fromSQL(this.ends_at || '').toFormat('HH:mm')}`,
      start: this.starts_at || '',
      end: this.ends_at || '',
      extendedProps: {
        hour_type: this.hour_type,
        description: this.description,
      },
      editable: true,
      className: `${this.hour_type}__event`,
    }
    return parsedEvent;
  }

  get backgroundEvent() {
    const parsedEvent: BackgroundEvent = {
      start: this.starts_at || '',
      end: this.ends_at || '',
      rendering: 'background',
    }
    return parsedEvent;
  }
}

// TODO: interface naar CalendarDefault
export interface CalendarEvent {
  id: string;
  title: string;
  start: string;
  end: string;
  editable?: boolean;
  className?: string;
  extendedProps?: object;
  constraint?: object;
}
